import { I18n, parseJSON, extractLocale } from "@utils/i18n"

declare global {
  interface Window {
    i18n: I18n
  }
}

export function setupI18n() {
  const json = parseJSON()
  const locale = extractLocale()

  window.i18n = new I18n(json, locale)
}
